import * as ApiEvents from './apiEvents'
import { showToast } from '../../commonComponents/showToast'
import { setErrorMessage } from '../actions'
import store from '../store'
import { HttpClient } from '../../../commonApis/httpClient'

export const saveEvent = (eventMessage) => ({
  eventType: ApiEvents.SAVE_FORM_NL,
  eventTime: Date.now(),
  eventMessage,
})
const saveItemEvent = (eventMessage) => ({
  eventType: ApiEvents.SAVE_C88_ITEM,
  eventTime: Date.now(),
  eventMessage,
})




export const HttpPostRequest = (requestParams, fieldName = '') => {
  return HttpClient.post(requestParams)
    .then((res) => {
      if (
        fieldName !== 'procedure' &&
        res.data.eventMessage.code !== 200 &&
        res.data.eventMessage.hasOwnProperty('code') === true
      ) {
        console.error(
          'errorCode :' + res.data.eventMessage.code,
          'eventMessage :' + res.data.eventMessage.msg
        )
        console.log('eventMessage :' + res.data.eventMessage.msg)
        store.dispatch(setErrorMessage('Data not saved, try again after sometime!'))
        showToast('Data not saved, try again after sometime!')
      } else {
        //   store.dispatch(setErrorMessage("Data saved successfully."))
        //  showToast("Data saved successfully.");
        res = res.data.eventMessage
      }

      return res
    })
    .catch((error) => {
      console.log('ERROR:: ' + error)
      showToast('Something went wrong, Check your network connection!')
      return ''
    })
}

export const saveShipmentDetail = (fieldName, value) => {
  let dataSent = saveEvent({
    [fieldName]: value,
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}





export const saveNotes = (noteId, fieldName, value) => {
  let dataSent = {
    eventType: ApiEvents.SAVE_SHIPMENT_NOTES,
    eventTime: Date.now(),
    eventMessage: {
      noteId,
      [fieldName]: value,
      shipmentId: window.shipmentId,
    },
  }

  return HttpPostRequest(dataSent)
}


export const saveAIStatementAndCodesInfo = (infoId, fieldName, value) => {
  let dataSent = saveEvent({
    aiStatementUkInfo: [
      {
        [fieldName]: value,
        infoId: infoId,
        shipmentId: window.shipmentId,
      },
    ],
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveLineItemAIInfo = (merchandiseId, infoId, fieldName, value) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          aiStatementUkInfo: [
            {
              [fieldName]: value,
              merchandiseId,
              infoId,
              shipmentId: window.shipmentId,
            },
          ],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}

export const saveLineItemSummaryInfo = (merchandiseId, infoId, fieldName, value) => {
  let dataSent = saveItemEvent({
    descriptionOfMerchandise: {
      merchandiseLineItems: [
        {
          merchandiseId,
          previousDocumentInfo: [
            {
              [fieldName]: value,
              merchandiseId,
              infoId,
              shipmentId: window.shipmentId,
            },
          ],
        },
      ],
    },
    shipmentId: window.shipmentId,
  })

  return HttpPostRequest(dataSent)
}
export const addNotesItem = (description, createdBy, hotCheckBox) => {
  let dataSent = {
    eventType: ApiEvents.SAVE_SHIPMENT_NOTES,
    eventTime: Date.now(),
    eventMessage: {
      shipmentId: window.shipmentId,
      status: '0',
      description,
      hot: hotCheckBox === true ? '1' : '0',
      userName: createdBy,
      dateOfNote: { epochs: new Date().getTime() },
    },
  }

  return dataSent
}


export const addAddInfo = () => {
  let dataSent = saveEvent({
    additionalInfos: [
      {
        shipmentId: window.shipmentId,
        infoId: '',
      },
    ],
    shipmentId: window.shipmentId,
  })

  return dataSent
}

export const addAIInfo = () => {
  let dataSent = saveEvent({
    aiStatementUkInfo: [
      {
        shipmentId: window.shipmentId,
        infoId: '',
      },
    ],
    shipmentId: window.shipmentId,
  })

  return dataSent
}


